import { render, staticRenderFns } from "./AreaHierarquica.vue?vue&type=template&id=45ae4302"
import script from "./AreaHierarquica.vue?vue&type=script&lang=js"
export * from "./AreaHierarquica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports